module.exports = __webpack_public_path__ + "img/mtbank_slide_3.efe04923.jpg";